import { FaMagnifyingGlass, FaXmark } from "react-icons/fa6";
import { ev } from "../../lib/everythingCopy";

export function SearchBar({ value, onChange }) {
  return (
    <section className="mb-5 flex-1 min-w-[200px] max-w-md">
      <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-400 dark:text-zinc-500 mb-1.5">
        {ev.searchTitle}
      </p>
      <div className="relative">
        <FaMagnifyingGlass
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-zinc-400 dark:text-zinc-500"
          aria-hidden
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={ev.searchPlaceholder}
          className="w-full rounded-full border border-zinc-200/70 dark:border-zinc-700/60 bg-white/40 dark:bg-zinc-900/40 backdrop-blur-sm pl-9 pr-9 py-2 text-xs font-medium text-zinc-800 dark:text-zinc-100 placeholder:text-zinc-400 dark:placeholder:text-zinc-600 focus:outline-none focus:ring-2 focus:ring-amber-300/40 focus:border-amber-300/60"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full hover:bg-zinc-200/60 dark:hover:bg-zinc-700/60 flex items-center justify-center text-zinc-400 dark:text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-200 transition-colors"
            aria-label={ev.searchClear}
            title={ev.searchClear}
          >
            <FaXmark className="w-3 h-3" />
          </button>
        )}
      </div>
    </section>
  );
}
